import React from "react";
import Icon from "./Icon";

export default function SearchInput({
  value,
  onChange,
  placeholder = "Search...",
  size = "md", // "sm" | "md" | "lg"
  width,
  style = {},
  className = "",
  autoFocus = false,
  disabled = false,
  onKeyDown,
}) {
  const sizeClass = size === "sm" ? "search-input-wrapper--sm" : size === "lg" ? "search-input-wrapper--lg" : "";
  const iconSize = size === "sm" ? 12 : size === "lg" ? 16 : 14;

  return (
    <div
      className={`search-input-wrapper ${sizeClass} ${className}`}
      style={{ width: width !== undefined ? width : "100%", ...style }}
    >
      <span className="search-input-icon">
        <Icon name="search" size={iconSize} color="#9CA3AF" />
      </span>
      <input
        type="text"
        className="search-input-field"
        placeholder={placeholder}
        value={value || ""}
        onChange={(e) => onChange && onChange(e.target.value)}
        autoFocus={autoFocus}
        disabled={disabled}
        onKeyDown={onKeyDown}
      />
    </div>
  );
}
